// removed by extract-text-webpack-plugin
module.exports = {"AboutPage":"AboutPage__AboutPage__3YQ0b","title":"AboutPage__title__2uAk9","window":"AboutPage__window__2pBf6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AboutPage/AboutPage.css
// module id = 66
// module chunks = 0